import LazyLoad from 'lazyload';

const lazyloadify = () => {
  if (!window.blubolt) {
    return
  }
  if (!window.blubolt.lazyLoadInstance) {
    window.blubolt.lazyLoadInstance = new LazyLoad({
      elements_selector: '[data-lazy-load]' // eslint-disable-line camelcase
    });
  } else {
    window.blubolt.lazyLoadInstance.update();
  }
}
export default lazyloadify;